import styled from 'styled-components';

import { ReplaceProductInTemplates } from './ReplaceProductInTemplates';
import { ProductModal } from './ProductModal';
import { MicrostoreItemType } from 'data/__generated__';
export const EndOfLifeProductModal = ({
    productId,
    displayKg,
    fullname,
    categoryId,
    portion,
    setIsOpen,
}: {
    productId: string;
    displayKg: boolean;
    fullname: string;
    categoryId: string;
    portion: number;
    setIsOpen: (isOpen: boolean) => void;
}) => {
    const closeModal = () => {
        setIsOpen(false);
    };

    return (
        <ModalContainer onClick={closeModal}>
            <Modal
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                <ModalTitle>Gérer les produits en fin de vie</ModalTitle>
                <SplitContainer>
                    <LeftPanel>
                        <ProductModal
                            productId={productId}
                            displayKg={displayKg}
                            fullname={fullname}
                            categoryId={categoryId}
                            portion={portion}
                        />
                    </LeftPanel>
                    <RightPanel>
                        <ModalTitle>Remplacer {fullname} dans tous les templates</ModalTitle>

                        <WarningText>
                            ⚠️ Attention : vérifiez que la dimension du produit de remplacement correspond à celle du
                            produit retiré (poids, volume, portions, compatibilité colonne).
                        </WarningText>

                        <ReplaceProductInTemplates
                            initialItemToRemove={{
                                _id: productId,
                                name: fullname,
                                type: MicrostoreItemType.Product,
                                locationCount: 0,
                            }}
                            showItemToRemoveSelect={false}
                        />
                    </RightPanel>
                </SplitContainer>
            </Modal>
        </ModalContainer>
    );
};

const ModalContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: #1116;
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
`;

const Modal = styled.div`
    border-top: 5px solid #ff6c25;
    background-color: ${({ theme }) => theme.backgroundColor};
    padding: 40px;
    width: 90%;
    max-width: 1800px;
    line-height: 20px;
    display: flex;
    flex-direction: column;
`;

const ModalTitle = styled.div`
    padding: 10px 0 20px 0;
    color: ${({ theme }) => theme.textColor};
    font-weight: bold;
    font-size: 1.8em;
`;

const SplitContainer = styled.div`
    display: flex;
    flex: 1;
    gap: 20px;
    overflow: hidden;
`;

const LeftPanel = styled.div`
    flex: 1;
    border-right: 1px solid ${({ theme }) => theme.lightBorderColor || '#ddd'};
    overflow-y: auto;
    padding-right: 20px;
`;

const RightPanel = styled.div`
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
`;

const WarningText = styled.div`
    margin-bottom: 15px;
    color: ${({ theme }) => theme.warningColor};
    font-weight: bold;
    text-align: center;
`;
